/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */


const theme = {
  appearances: {
    highlight: { type: 'variant', values: [ 'row' ] },
    spacing: {
      description: 'Adjusts the height of the table cell',
      type: 'variant',
      values: [ 'compact', 'default' ]
    },
    text: { type: 'variant', values: [ 'small' ] },
    type: {
      type: 'variant',
      values: [ 'subHeading', 'rowHeading', 'heading', 'default' ]
    }
  },
  rules: [
    {
      if: { highlight: 'row' },
      tokens: {
        cellBackground: 'rgba(0, 0, 0, 0)',
        rowHoverBackgroundColor: 'rgba(0, 0, 0, 0.05)'
      }
    },
    {
      if: { spacing: 'compact' },
      tokens: {
        cellPaddingBottom: 8,
        cellPaddingTop: 8,
        fontSize: 16,
        lineHeight: 1.25
      }
    },
    {
      if: { spacing: 'compact', type: 'rowHeading' },
      tokens: {
        cellPaddingBottom: 8,
        cellPaddingTop: 8,
        fontName: 'StagSans',
        fontSize: 16,
        fontWeight: '600',
        lineHeight: 1.25
      }
    },
    {
      if: { spacing: 'compact', type: 'subHeading' },
      tokens: {
        cellPaddingBottom: 8,
        cellPaddingTop: 8,
        fontName: 'StagSans',
        fontSize: 16,
        fontWeight: '600',
        lineHeight: 1.25
      }
    },
    {
      if: { spacing: 'default', type: 'heading' },
      tokens: {
        cellBackground: '#000000',
        cellBoxShadowColor: 'rgba(0, 0, 0, 0)',
        fontColor: '#ffffff',
        fontName: 'StagSans',
        fontSize: 16,
        fontWeight: '600',
        lineHeight: 1.5
      }
    },
    {
      if: { spacing: 'compact', type: 'heading' },
      tokens: {
        cellBackground: '#000000',
        cellBoxShadowColor: 'rgba(0, 0, 0, 0)',
        cellPaddingBottom: 8,
        cellPaddingTop: 8,
        fontColor: '#ffffff',
        fontName: 'StagSans',
        fontSize: 16,
        fontWeight: '600',
        lineHeight: 1.25
      }
    },
    {
      if: { text: 'small', type: 'subHeading' },
      tokens: { fontName: 'StagSans', fontSize: 16, fontWeight: '600' }
    },
    {
      if: { spacing: 'default', type: 'rowHeading' },
      tokens: {
        fontName: 'StagSans',
        fontSize: 16,
        fontWeight: '600',
        lineHeight: 1.5
      }
    },
    {
      if: { text: 'small', type: 'default' },
      tokens: {
        fontName: 'StagSans',
        fontSize: 14,
        fontWeight: '400',
        lineHeight: 1.42857142857
      }
    },
    {
      if: { text: 'small', type: 'rowHeading' },
      tokens: {
        fontName: 'StagSans',
        fontSize: 14,
        fontWeight: '600',
        lineHeight: 1.42857142857
      }
    },
    {
      if: { spacing: 'compact', text: 'small', type: 'rowHeading' },
      tokens: {
        fontName: 'StagSans',
        fontSize: 14,
        fontWeight: '600',
        lineHeight: 1.14285714286
      }
    },
    {
      if: { spacing: 'compact', text: 'small', type: 'default' },
      tokens: { lineHeight: 1.14285714286 }
    }
  ],
  tokens: {
    borderColor: '#efefef',
    borderWidth: 1,
    cellBackground: '#ffffff',
    cellBorderColor: 'rgba(0, 0, 0, 0)',
    cellBorderTopWidth: 0,
    cellBorderWidth: 0,
    cellBoxShadowColor: '#efefef',
    cellMinWidth: 0,
    cellPaddingBottom: 16,
    cellPaddingLeft: 16,
    cellPaddingRight: 16,
    cellPaddingTop: 16,
    cellStickyShadow: {
      blur: 8,
      color: 'rgba(0, 0, 0, 0.1)',
      inset: false,
      offsetX: 0,
      offsetY: 4,
      spread: 0
    },
    display: null,
    fontColor: '#000000',
    fontName: 'StagSans',
    fontSize: 16,
    fontWeight: '400',
    lineHeight: 1.5,
    rowBorderColor: 'rgba(0, 0, 0, 0)',
    rowBorderTopWidth: 0,
    rowBorderWidth: 0,
    rowHoverBackgroundColor: 'rgba(0, 0, 0, 0)',
    stickyBackgroundColor: '#ffffff',
    tablePaddingBottom: 24
  }
}
export default theme
